module.exports = initialState => {
  let _state = {}
  let _layers = []
  if (initialState != null) Object.assign(_state, initialState)
  return {
    apply: diff => Object.assign(_state, diff),
    _state: () => _state,
    clear: () => {
      _state = {}
    },
    get: () => {
      const result = {}
      Object.assign(result, _state)
      for (const layer of _layers)
        Object.assign(result, layer)
      return result
    },
    layer: layer => {
      _layers.push(layer)
      return {
        rollback: () => {
          _layers.splice(_layers.indexOf(layer), 1)
        },
        commit: () => {
          _layers.splice(_layers.indexOf(layer), 1)
          Object.assign(_state, layer)
        }
      }
    }
  }
}